// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100px;
}

.loading-text {
  position: relative;
  font-weight: bold;
  font-size: 1.25rem;
  color: #007bff;
  animation: pulse 1.5s infinite ease-in-out;
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.6;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.1);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Authentication/Authentication.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AACJ;;AAEE;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,0CAAA;AACJ;;AAEE;EACE;IACE,YAAA;IACA,mBAAA;EACJ;EACE;IACE,UAAA;IACA,qBAAA;EACJ;AACF","sourcesContent":[".loading-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 100px;\n  }\n  \n  .loading-text {\n    position: relative;\n    font-weight: bold;\n    font-size: 1.25rem;\n    color: #007bff;\n    animation: pulse 1.5s infinite ease-in-out;\n  }\n  \n  @keyframes pulse {\n    0%, 100% {\n      opacity: 0.6;\n      transform: scale(1);\n    }\n    50% {\n      opacity: 1;\n      transform: scale(1.1);\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
